import { render } from "./PaymentAddEdit.vue?vue&type=template&id=183dad76&scoped=true"
import script from "./PaymentAddEdit.vue?vue&type=script&lang=js"
export * from "./PaymentAddEdit.vue?vue&type=script&lang=js"

import "./PaymentAddEdit.vue?vue&type=style&index=0&id=183dad76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183dad76"]])

export default __exports__